import React from 'react';
import PropTypes from 'prop-types';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import Avatar from '../../Avatar';

import { getFormattedDateTime } from '../../../helpers/DateTime';

const AdminFTPAccountsListItem = ({
  account,
  openFTPAccountEditModal,
  handleDeleteAccount,
}) => {
  const accountUser = account.user || account.created_by;

  const intl = useIntl();

  return (
    <tr>
      <th scope="row" className="account-login">
        <div className="account-avatar">
          <div className="avatar avatar-40 icon-avatar gray">
            <i className="far fa-server" />
          </div>
        </div>
        <div className="account-login-container">
          {account.login}@{account.login_suffix}
        </div>
      </th>
      <td className="account-description">
        {account.description}
      </td>
      <td className="account-collection">
        {account.collection && (
          <a href={`/collections/${account.collection.uuid}`} target="_blank" rel="noopener noreferrer">
            {account.collection.name}
          </a>
        )}
      </td>
      <td className="account-user">
        {accountUser && (
          <a href={`/admin/users/${accountUser.uuid}/edit`} target="_blank" rel="noopener noreferrer">
            <Avatar user={accountUser} />
            {accountUser.name}
          </a>
        )}
      </td>
      <td className="account-created-at">
        {getFormattedDateTime(account.created_at)}
      </td>
      <td className="action-more">
        <UncontrolledDropdown>
          <DropdownToggle nav className="options">
            <i className="far fa-ellipsis-h" />
          </DropdownToggle>
          <DropdownMenu right>
            <DropdownItem onClick={() => { openFTPAccountEditModal(account); }}>
              <i className="fas fa-pencil" />
              {intl.formatMessage({ defaultMessage: 'Edit' })}
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem onClick={() => { handleDeleteAccount(account.id); }}>
              <i className="fas fa-trash" />
              {intl.formatMessage({ defaultMessage: 'Delete' })}
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </td>
    </tr>
  );
};

AdminFTPAccountsListItem.propTypes = {
  account: PropTypes.object.isRequired,
  openFTPAccountEditModal: PropTypes.func.isRequired,
  handleDeleteAccount: PropTypes.func.isRequired,
};

export default AdminFTPAccountsListItem;
